export default __webpack_public_path__ + "static/media/register_m-ic-light.daf98622.svg";